import { ButtonPopup } from "@/components/ui";
import { motion } from "framer-motion";
import React from "react";
import { useNavigate } from "react-router-dom";


interface Props {
    onReconsider?: () => void;
}

const CookieBlockedLanding: React.FC<Props> = ({ onReconsider }) => {
    const navigate = useNavigate();

    const volverAConfigurar = () => {
        if (onReconsider) {
            onReconsider(); // 👈 vuelve a abrir modal
        } else {
            navigate("/politicaCookies");
        }
    };

    const salir = () => {
        window.location.href = "https://www.google.com";
    };


    return (
        <div
            className="w-full h-screen flex items-center justify-center px-4 py-8 bg-cover bg-center relative"
            style={{ backgroundImage: "url('/img/politicas/cookiesLinkServs.png')" }}
        >
            {/* Overlay más fino */}
            <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" />

            <motion.div
                initial={{ opacity: 0, y: 30, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 1 }}
                className="relative z-10 w-full max-w-xl"
            >
                <div className="p-8 rounded-2xl border-4 border-transparent shadow-xl shadow-zinc-600 bg-white/5 backdrop-blur-4xl text-white">

                    <h1 className="text-3xl font-bold mb-4">
                        Necesitamos tu consentimiento
                    </h1>

                    <p className="mb-4 text-white/80">
                        Este sitio utiliza cookies esenciales para funcionar correctamente.
                    </p>

                    <p className="mb-4 text-white/70">
                        Usamos cookies para:
                    </p>

                    <ul className="text-left list-disc pl-6 mb-6 text-white/80 space-y-2">
                        <li>Guardar tu sesión de usuario</li>
                        <li>Mejorar la experiencia de navegación</li>
                        <li>Analizar el uso de la plataforma</li>
                        <li>Personalizar contenido y servicios</li>
                    </ul>

                    {/* 🔥 NUEVO BLOQUE PRO */}
                    <div className="mb-6 p-4 rounded-lg bg-black/25 border border-white/10 text-white/70 text-sm leading-relaxed">
                        Lo sentimos, pero si no acepta el uso de cookies, no podremos garantizar el acceso a las funciones personalizadas y datos almacenados en nuestra plataforma.
                        Para ofrecerle una experiencia segura y fluida, estas herramientas son esenciales, ya que nos permiten reconocer su sesión y proteger su información.
                        Si desea continuar disfrutando de todas las ventajas de la aplicación, le invitamos a revisar y actualizar sus preferencias de privacidad.
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <ButtonPopup
                            onClick={volverAConfigurar}
                            className="min-w-[12rem] text-lg bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-md transition"
                        >
                            Revisar cookies
                        </ButtonPopup>

                        <ButtonPopup
                            onClick={salir}
                            className="min-w-[12rem] text-lg bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md transition"
                        >
                            Salir del sitio
                        </ButtonPopup>
                    </div>

                </div>
            </motion.div>
        </div>
    );
};

export default CookieBlockedLanding;